<div
	class="flex min-h-[45vh] flex-col items-center justify-center gap-4 text-center"
	role="status"
	aria-live="polite"
	aria-busy="true"
>
	<div
		class="h-12 w-12 animate-spin rounded-full border-[0.3rem] border-[#d8e3f5] border-t-[#0f62fe]"
		aria-hidden="true"
	></div>
	<p class="m-0 text-[1.1rem] font-semibold text-[#1f2937]">
		Login, please wait
		<span class="inline-flex w-7 justify-start" aria-hidden="true">
			<span class="inline-block animate-bounce [animation-delay:0ms]">.</span>
			<span class="inline-block animate-bounce [animation-delay:150ms]">.</span>
			<span class="inline-block animate-bounce [animation-delay:300ms]">.</span>
		</span>
	</p>
</div>
